export default __webpack_public_path__ + "static/media/promo-logo.c0db94c5.svg";